import React from 'react'

export const ColumnHeader: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    return <div className="public-notice__table-header">{children}</div>
}
